// extracted by mini-css-extract-plugin
module.exports = {"logo":"Header_logo__12vnW","Header":"Header_Header__2Xdmp","name":"Header_name__2tV_D","title":"Header_title__1NwhM"};